module.exports = __webpack_public_path__ + "img/img10.0ae4ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img10.png
// module id = 186
// module chunks = 0